import {ReportLowBatteryModel} from "../../models/reports/ReportLowBatteryModel";

export class ReportLowBatteryCtrl {
    public static $inject = ['$scope','ReportLowBatteryModel'];
    constructor(public $scope:any, public model:ReportLowBatteryModel) {
        $scope.vm = this;
    }
}
